export const GET_ALL_USERS = 'GET_ALL_USERS';

export const getAllUsers = (data) => dispatch =>
    dispatch({
        type: GET_ALL_USERS,
        payload: data
    });
